import { Route, Routes } from 'react-router-dom';
import { routes } from '../constants/appRoutes';
import { AcceptedPromoPage, ContractPage, ErrorPage, ExpiredPromoPage, ExpiredToken, HomePage, InvalidTokenPage, InvalidUserPage, LoginPage, NotFoundPage, RefusedPromoPage, SendReminderSuccessPage } from '../features';
import { ConfirmedPromoPage } from '../features/ConfirmedPromoPage';
import { NotConfirmedPromoPage } from '../features/NotConfirmedPromoPage';
import { AppOutletLayout } from './AppOutletLayout';
import { ProtectedOutlet } from './ProtectedOutlet';

export const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<AppOutletLayout />}>
                <Route index element={<ErrorPage />} />
                <Route path={routes.sendReminder} element={<SendReminderSuccessPage />} />
                <Route path={routes.loginRoute} element={<LoginPage />} />
                <Route path={routes.confirmedContract} element={<ConfirmedPromoPage />} />
                <Route path={routes.notConfirmedContract} element={<NotConfirmedPromoPage />} />
                <Route path={routes.accepted} element={<AcceptedPromoPage />} />
                <Route path={routes.refused} element={<RefusedPromoPage />} />
                <Route path={routes.expired} element={<ExpiredPromoPage />} />
            </Route>
            <Route path={routes.app} element={<ProtectedOutlet />}>
                <Route index element={<HomePage />} />
                <Route path={routes.contract} element={<ContractPage />} />
            </Route>
            <Route path={routes.errors} element={<AppOutletLayout />}>
                <Route index element={<ErrorPage />} />
                <Route path={routes.statusCode404} element={<NotFoundPage />} />
                <Route path={routes.statusCode520} element={<InvalidUserPage/>} />
                <Route path={routes.statusCode301} element={<InvalidTokenPage />} />
                <Route path={routes.statusCode201} element={<ExpiredToken />} />
            </Route>
        </Routes>
    );
};
